import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { FETCH_UPDATES } from '@/store/entries/constants'
import { USER_LOAD } from '@/store/share/constants'
import { SETTINGS_LOAD_PREFERENCES } from '@/store/settings/constants'
import API from '@/util/api/API'
import UIState from './types'
import { INITIAL_CONNECT, UI_SET_IS_ONLINE } from './constants'

const actions: ActionTree<UIState, RootState> = {
    async [INITIAL_CONNECT]({ commit, dispatch }) {
        try {
            await dispatch(FETCH_UPDATES)
            commit(UI_SET_IS_ONLINE, true)
            API.whenConnected(() => {
                Promise.all([dispatch(USER_LOAD), dispatch(SETTINGS_LOAD_PREFERENCES)])
            })
        } catch (err) {
            commit(UI_SET_IS_ONLINE, false)
        }
    }
}

export default actions
